import React from 'react';
import PropTypes from 'prop-types';
import { ImageBackground, Text, View } from 'react-native';
import { CommonActions } from '@react-navigation/native';
import Carousel, { Pagination } from 'react-native-snap-carousel';

import Icon from 'LocalGluons/components/Icon';
import Button from 'LocalGluons/components/Button';
import storeActions from 'Store/storeActions';
import {
    getActualHeight,
    getActualWidth,
    addOrientationListener,
    removeOrientationListener
} from 'DeviceUtils';
import { withStore } from 'Store';
import { ONBOARDING_CONFIG } from '../../../options';

import defaultStyles from './Onboarding.jss';

class Onboarding extends React.Component {
    static propTypes = {
        deviceStorageDispatch: PropTypes.func.isRequired,
        navigation: PropTypes.shape({}).isRequired
    };

    constructor(props) {
        super(props);
        this.carouselRef = null;

        this.state = {
            activeDotIndex: 0
        };

        this.items = ONBOARDING_CONFIG.items;
        this.orientationListener = () => {
            this.forceUpdate();
        };
    }

    componentDidMount() {
        addOrientationListener(this.orientationListener);
    }

    componentWillUnmount() {
        removeOrientationListener(this.orientationListener);
    }

    onSnapToItem = (index) => {
        this.setState({ activeDotIndex: index });
    };

    onClose = () => {
        const { deviceStorageDispatch, navigation } = this.props;
        deviceStorageDispatch({ type: storeActions.setOnboardingCompleted, payload: true });
        const resetAction = CommonActions.reset({
            index: 0,
            routes: [{ name: 'Main' }]
            // actions: [navigation.navigate('Main')]
        });
        navigation.dispatch(resetAction);
    };

    renderScreenItem = ({ item, index }) => {
        const handleError = (err) => {
            console.log(err.nativeEvent.error);
        };

        const buttonHasTitle = Boolean(
            typeof item.getButtonTitle === 'function' && item.getButtonTitle()
        );

        const testId = `onboarding_screen_${index}`;
        const text = item.getTitle().toUpperCase();
        return (
            <View style={{ flex: 1 }} testID={testId}>
                <ImageBackground
                    onError={handleError}
                    style={[defaultStyles.imageBackground]}
                    source={item.source}
                />
                <View style={defaultStyles.imageBackground}>
                    <View
                        style={
                            buttonHasTitle
                                ? defaultStyles.textsContainerWithButton
                                : defaultStyles.textsContainer
                        }
                    >
                        <Text style={defaultStyles.title}>{text}</Text>
                        {buttonHasTitle && (
                            <Button
                                title={item.getButtonTitle()}
                                style={{ button: defaultStyles.button }}
                                onPress={this.onClose}
                            />
                        )}
                    </View>
                </View>
            </View>
        );
    };

    render() {
        const { activeDotIndex } = this.state;
        const { navigation, route } = this.props;
        const { customOnboardingItems } = route.params || {};
        const hasCustomOnboardingItems = Boolean(customOnboardingItems?.length > 0);
        const items = hasCustomOnboardingItems ? customOnboardingItems : this.items;
        const itemsLength = items.length;
        const width = getActualWidth();
        const height = getActualHeight();

        return (
            <View style={{ height: '100%', width: '100%' }}>
                <>
                    <Icon
                        name="close"
                        onPress={this.onClose}
                        style={defaultStyles.closeIcon}
                        testID="close_button"
                    />
                    <Carousel
                        key="onboardingCarousel"
                        ref={(carousel) => {
                            this.carouselRef = carousel;
                        }}
                        data={items}
                        testID="onboarding_carousel"
                        sliderWidth={width}
                        itemWidth={width}
                        sliderHeight={height}
                        itemHeight={height}
                        renderItem={this.renderScreenItem}
                        inactiveSlideScale={0.95}
                        inactiveSlideOpacity={0.5}
                        containerCustomStyle={defaultStyles.carousel}
                        onSnapToItem={this.onSnapToItem}
                    />
                    {activeDotIndex + 1 !== itemsLength && (
                        <Pagination
                            key="onboardingPagination"
                            dotsLength={itemsLength}
                            activeDotIndex={activeDotIndex}
                            dotColor="#fff"
                            inactiveDotColor="#fff"
                            inactiveDotOpacity={0.3}
                            inactiveDotScale={1}
                            carouselRef={this.carouselRef}
                            tappableDots={!!this.carouselRef}
                            dotContainerStyle={defaultStyles.paginationDotContainer}
                            containerStyle={defaultStyles.paginationContainer}
                            dotStyle={defaultStyles.dotStyle}
                        />
                    )}
                </>
            </View>
        );
    }
}

export default withStore(Onboarding);
